// @flow

import AES from 'crypto-js/aes'
import Utf8 from 'crypto-js/enc-utf8'

export function decrypt (ciphertext: string): string {
  var bytes = AES.decrypt(ciphertext, 'oSfMUpbitrTeAZHP')
  var originalText = bytes.toString(Utf8)
  return originalText
}



// WEBPACK FOOTER //
// ./src/frame/core/cryptoAes.js